import Image, { StaticImageData } from 'next/image';

import { animated, config, useSpring } from '@react-spring/web';

import checkIcon from '../_assets/check-icon.svg';

const AnimatedDiv = animated('div');

export default function GameResultDialogHeaderAnimation({
  image,
  headerContent,
}: {
  image?: StaticImageData | null;
  headerContent?: React.ReactNode;
}) {
  const [style] = useSpring(() => ({
    from: { transform: `translateY(-2rem)` },
    to: { transform: `translateY(0)` },
    config: config.wobbly,
  }));

  return (
    <div className='relative'>
      <AnimatedDiv
        aria-hidden='true'
        className='absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2'
        style={style}
      >
        {headerContent ? (
          <div className='flex h-16 w-24 items-center justify-center md:h-20 md:w-32'>{headerContent}</div>
        ) : image ? (
          <Image
            aria-hidden
            className='h-16 w-24 object-contain md:h-20 md:w-32'
            src={image}
            alt=''
            width={672}
            height={346}
          />
        ) : (
          <Image
            aria-hidden
            className='h-16 w-24 object-contain md:h-20 md:w-32'
            src={checkIcon}
            alt=''
            width={672}
            height={346}
          />
        )}
      </AnimatedDiv>
      <svg
        aria-hidden='true'
        className='h-auto w-full'
        width='672'
        height='346'
        viewBox='0 0 672 346'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g clipPath='url(#clip0_17314_9372)'>
          <rect width='672' height='345.248' fill='url(#paint0_radial_17314_9372)' />
          <path
            opacity='0.75'
            d='M337.027 -209.615L338.619 142.086L376.767 -207.521L341.785 142.421L416.072 -201.262L344.899 143.086L454.51 -190.907L347.927 144.075L491.662 -176.569L350.835 145.377L527.119 -158.405L353.592 146.978L560.494 -136.614L356.168 148.859L591.42 -111.435L358.534 151.001L619.559 -83.1442L360.664 153.379L644.602 -52.0509L362.535 155.969L666.276 -18.496L364.127 158.741L684.342 17.1529L365.422 161.665L698.603 54.5051L366.406 164.709L708.903 93.1514L367.067 167.84L715.128 132.668L367.4 171.023L717.211 172.623L367.4 174.224L715.128 212.578L367.067 177.407L708.903 252.095L366.406 180.538L698.603 290.741L365.422 183.582L684.342 328.094L364.127 186.506L666.276 363.743L362.535 189.278L644.602 397.297L360.664 191.867L619.559 428.391L358.534 194.246L591.42 456.682L356.168 196.388L560.494 481.861L353.592 198.269L527.119 503.652L350.835 199.869L491.662 521.816L347.927 201.171L454.51 536.154L344.899 202.16L416.072 546.509L341.785 202.826L376.767 552.768L338.619 203.16L337.027 554.862L335.435 203.16L297.287 552.768L332.269 202.826L257.983 546.509L329.155 202.16L219.544 536.154L326.128 201.171L182.393 521.816L323.219 199.869L146.936 503.652L320.462 198.269L113.561 481.861L317.887 196.388L82.6348 456.682L315.521 194.246L54.4958 428.391L313.391 191.867L29.4523 397.297L311.519 189.278L7.77869 363.743L309.928 186.506L-10.2877 328.094L308.633 183.582L-24.5487 290.741L307.649 180.538L-34.8483 252.095L306.987 177.407L-41.0736 212.578L306.654 174.224L-43.1562 172.623L306.654 171.023L-41.0736 132.668L306.987 167.84L-34.8483 93.1514L307.649 164.709L-24.5487 54.5051L308.633 161.665L-10.2877 17.1529L309.928 158.741L7.77869 -18.496L311.519 155.969L29.4523 -52.0509L313.391 153.379L54.4958 -83.1442L315.521 151.001L82.6348 -111.435L317.887 148.859L113.561 -136.614L320.462 146.978L146.936 -158.405L323.219 145.377L182.393 -176.569L326.128 144.075L219.544 -190.907L329.155 143.086L257.983 -201.262L332.269 142.421L297.287 -207.521L335.435 142.086L337.027 -209.615Z'
            fill='white'
            className='animate-spin-reverse origin-center'
          />
          <ellipse cx='333.945' cy='160.293' rx='212.697' ry='211.67' fill='url(#paint1_radial_17314_9372)' />
          <path
            opacity='0.75'
            d='M526.721 270.181C524.257 268.835 522.345 269.313 520.658 269.735C519.04 270.14 517.642 270.489 515.708 269.432C513.773 268.375 513.313 267.011 512.779 265.43C512.223 263.782 511.593 261.915 509.129 260.569C506.667 259.224 504.755 259.702 503.068 260.125C501.451 260.53 500.055 260.88 498.122 259.824C496.188 258.767 495.728 257.402 495.194 255.822C494.639 254.175 494.008 252.307 491.546 250.962C489.084 249.617 487.173 250.095 485.485 250.518C483.869 250.923 482.472 251.273 480.54 250.217C478.608 249.161 478.148 247.797 477.616 246.218C477.06 244.571 476.43 242.703 473.969 241.358C473.596 241.154 473.128 241.291 472.923 241.665C472.719 242.039 472.856 242.507 473.23 242.711C475.162 243.767 475.622 245.131 476.155 246.71C476.71 248.358 477.34 250.225 479.801 251.569C482.262 252.915 484.173 252.436 485.861 252.014C487.477 251.608 488.874 251.258 490.807 252.315C492.741 253.371 493.201 254.735 493.734 256.315C494.29 257.963 494.92 259.831 497.383 261.176C499.844 262.521 501.756 262.043 503.443 261.621C505.06 261.215 506.457 260.865 508.39 261.922C510.325 262.979 510.785 264.344 511.319 265.924C511.875 267.572 512.505 269.439 514.969 270.785C517.432 272.131 519.344 271.653 521.031 271.231C522.65 270.826 524.047 270.477 525.982 271.534C526.355 271.738 526.823 271.601 527.028 271.227C527.232 270.853 527.095 270.386 526.721 270.181L526.721 270.181Z'
            fill='#0071CE'
          />
          <path
            opacity='0.75'
            d='M193.396 96.2725C190.932 94.9279 189.02 95.407 187.333 95.8302C185.715 96.236 184.318 96.586 182.383 95.5301C180.447 94.474 179.986 93.1096 179.452 91.5294C178.895 89.882 178.263 88.015 175.799 86.6703C173.336 85.3263 171.425 85.8058 169.738 86.23C168.121 86.6353 166.725 86.986 164.791 85.931C162.857 84.8755 162.396 83.5111 161.862 81.9312C161.305 80.284 160.674 78.4169 158.211 77.0731C155.748 75.7292 153.837 76.2086 152.15 76.6328C150.533 77.0381 149.137 77.3888 147.204 76.3341C145.272 75.2796 144.811 73.9156 144.278 72.3367C143.722 70.6896 143.091 68.8223 140.629 67.4789C140.255 67.2749 139.787 67.4121 139.583 67.7863C139.379 68.1601 139.516 68.6281 139.89 68.8323C141.823 69.887 142.283 71.251 142.817 72.8299C143.373 74.477 144.004 76.3436 146.466 77.687C148.928 79.0307 150.839 78.5509 152.526 78.128C154.142 77.7214 155.539 77.3708 157.473 78.4261C159.407 79.4816 159.867 80.8455 160.401 82.4247C160.958 84.0729 161.59 85.9399 164.053 87.2841C166.516 88.6278 168.426 88.1481 170.114 87.7251C171.73 87.3188 173.127 86.9682 175.061 88.0235C176.996 89.0795 177.457 90.444 177.992 92.0241C178.549 93.6715 179.18 95.5386 181.644 96.8833C184.109 98.2279 186.021 97.7488 187.707 97.3256C189.325 96.9201 190.723 96.57 192.658 97.6257C193.031 97.8297 193.499 97.6925 193.704 97.3183C193.908 96.9446 193.77 96.477 193.396 96.2728L193.396 96.2725Z'
            fill='#ED255E'
          />
          <path
            opacity='0.75'
            d='M86.7193 38.3331L71.1236 67.9089C69.891 70.6505 70.002 73.3359 71.4547 75.9639L86.7884 105.568C89.7487 112.166 85.3526 119.748 77.2434 118.749L44.0537 112.766C40.6701 112.238 38.041 113.695 36.1102 115.794L12.8846 139.645C7.73587 145.243 -1.12767 142.258 -2.10129 134.905L-7.50534 101.515C-7.61453 98.8305 -9.76568 95.5605 -12.5056 94.332L-42.6993 79.4801C-48.8752 76.3817 -49.2614 66.9852 -43.3596 63.3711L-13.7359 47.9891C-11.1052 46.5335 -9.17438 44.4342 -8.64168 41.0489L-3.94998 7.90317C-2.88282 1.13397 5.70436 -2.59371 11.2937 2.54701L34.4603 26.4376C36.5567 28.3657 39.2966 29.5942 42.6258 28.7806L75.3188 22.6806C84.7714 23.6241 90.4701 31.4488 86.7193 38.3331Z'
            fill='#FFDD00'
          />
          <path
            opacity='0.75'
            d='M621.12 212.948L625.12 228.086C625.565 229.422 626.454 230.313 627.788 230.758L642.459 236.101C645.571 237.437 646.459 241.444 643.347 243.67L630.011 252.13C628.677 253.02 628.232 254.356 628.232 255.692L627.788 271.276C627.788 274.838 623.786 276.619 621.12 274.393L608.672 264.597C607.783 263.707 606.005 263.261 604.671 263.707L589.555 268.159C586.444 269.049 583.332 265.933 584.221 262.816L589.555 248.123C590 246.787 590 245.451 589.111 244.115L580.22 231.203C578.442 228.531 580.22 224.524 583.776 224.524L599.336 225.415C600.669 225.415 602.003 224.97 602.893 223.634L612.228 211.167C615.785 208.495 620.23 209.386 621.12 212.948Z'
            fill='#FEDE0A'
          />
          <path
            opacity='0.75'
            d='M544.71 43.4578L544.647 43.9264L544.962 44.2788L550.575 50.5533L542.23 49.4432L541.761 49.3808L541.409 49.6959L535.133 55.3081L536.244 46.9633L536.307 46.4946L535.992 46.1423L530.379 39.8664L538.724 40.9779L539.193 41.0403L539.545 40.7251L545.82 35.1117L544.71 43.4578Z'
            stroke='#ED255E'
            strokeWidth='2.05505'
          />
          <path
            opacity='0.75'
            d='M208.043 237.28L208.03 237.752L208.38 238.069L214.029 243.182L206.413 242.978L205.94 242.965L205.623 243.316L200.51 248.964L200.715 241.348L200.727 240.876L200.377 240.559L194.727 235.445L202.344 235.65L202.817 235.663L203.134 235.312L208.247 229.662L208.043 237.28Z'
            stroke='#0071CE'
            strokeWidth='2.05505'
          />
          <path
            opacity='0.75'
            d='M466.32 125.136L466.646 125.478L467.118 125.453L473.129 125.141L468.77 129.291L468.427 129.617L468.452 130.089L468.764 136.1L464.614 131.74L464.288 131.398L463.816 131.423L457.805 131.735L462.165 127.585L462.507 127.259L462.483 126.787L462.17 120.776L466.32 125.136Z'
            stroke='#1BA5A4'
            strokeWidth='2.05505'
          />
          <circle opacity='0.75' cx='89.3953' cy='198.311' r='14.3853' stroke='#1BA5A4' strokeWidth='2.05505' />
          <circle opacity='0.75' cx='572.33' cy='140.768' r='12.3303' stroke='#0071CE' strokeWidth='2.05505' />
          <rect
            opacity='0.75'
            x='373.529'
            y='50.0539'
            width='10.2752'
            height='10.2752'
            transform='rotate(-27.3499 373.529 50.0539)'
            stroke='#3052C6'
            strokeWidth='2.05505'
          />
        </g>
        <defs>
          <radialGradient
            id='paint0_radial_17314_9372'
            cx='0'
            cy='0'
            r='1'
            gradientUnits='userSpaceOnUse'
            gradientTransform='translate(337.047 -1.07819e-06) rotate(90.0032) scale(345.248 550.77)'
          >
            <stop stopColor='#EEDE49' />
            <stop offset='1' stopColor='#FFDD00' stopOpacity='0' />
          </radialGradient>
          <radialGradient
            id='paint1_radial_17314_9372'
            cx='0'
            cy='0'
            r='1'
            gradientUnits='userSpaceOnUse'
            gradientTransform='translate(333.945 160.293) rotate(90) scale(211.67 212.697)'
          >
            <stop stopColor='white' />
            <stop offset='1' stopColor='white' stopOpacity='0' />
          </radialGradient>
          <clipPath id='clip0_17314_9372'>
            <rect width='672' height='345.248' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}
